// Per-product brand configs designed to closely resemble the printed Andrich catalog.
// Fields:
//   layout: "capsule" | "capsule-split" | "rounded" | "rounded-split" | "script" | "banner"
//   primary: main text; suffix: right-side text (e.g., "-5", "Plus", "Forte", "LB", "Oil", "M")
//   bg / bg2: background(s)
//   text / text2: text colors
//   accent: highlight color (for suffix badge)
//   italic: script-style italics
//   badge: tiny form tag shown outside the label (e.g., "Tablets", "Capsule", "Cream")

export const PRODUCT_BRAND = {
  "Tofarich-5": {
    layout: "capsule-split", primary: "Tofarich", suffix: "-5",
    bg: "#0d9488", bg2: "#0f766e", text: "#ffffff", text2: "#ffffff",
    accent: "#5eead4", badge: "Tablets", italic: false,
  },
  "Koziend": {
    layout: "script", primary: "Koziend", suffix: "",
    bg: "#ffffff", text: "#1d4ed8",
    accent: "#f97316", badge: "Skin Lightening Cream 15gm", italic: true,
  },
  "Q-RICH-10": {
    layout: "capsule-split", primary: "Q-RICH", suffix: "10",
    bg: "#7f1d1d", bg2: "#991b1b", text: "#ffffff", text2: "#ffffff",
    accent: "#fca5a5", badge: "Tablets", italic: false,
  },
  "Azamed": {
    layout: "rounded-split", primary: "Aza", suffix: "med",
    bg: "#f97316", bg2: "#dc2626", text: "#ffffff", text2: "#ffffff",
    accent: "#fef3c7", badge: "Tablets", italic: false,
  },
  "Melabond Plus": {
    layout: "rounded", primary: "Melabond", suffix: "Plus",
    bg: "#bfdbfe", text: "#1e3a8a",
    accent: "#dc2626", badge: "Tablets", italic: false, primaryBold: true,
  },
  "OSTRUM Forte": {
    layout: "rounded", primary: "OSTRUM", suffix: "Forte",
    bg: "#f59e0b", bg2: "#f97316", text: "#ffffff",
    accent: "#fef3c7", badge: "Capsule", italic: true, primaryBold: true,
  },
  "Kuvarich-25": {
    layout: "capsule-split", primary: "Kuvarich", suffix: "-25",
    bg: "#3f3f46", bg2: "#52525b", text: "#ffffff", text2: "#ffffff",
    accent: "#a3e635", badge: "Tablets", italic: false,
  },
  "Melabond": {
    layout: "banner", primary: "Melabond", suffix: "Oil",
    bg: "#ffffff", text: "#991b1b",
    accent: "#16a34a", badge: "Oil", italic: false, primaryBold: true,
  },
  "Venoset": {
    layout: "banner", primary: "Venoset", suffix: "",
    bg: "#ffffff", text: "#166534",
    accent: "#1e3a8a", badge: "Tablets", italic: false, primaryBold: true,
  },
  "TACRORICH Lotion": {
    layout: "script", primary: "TACRORICH", suffix: "Lotion",
    bg: "#ffffff", text: "#1d4ed8",
    accent: "#0f766e", badge: "Lotion", italic: true,
  },
  "Doxyrich LB": {
    layout: "rounded-split", primary: "Doxyrich", suffix: "LB",
    bg: "#1e3a8a", bg2: "#f97316", text: "#ffffff", text2: "#ffffff",
    accent: "#fed7aa", badge: "Capsules", italic: false, primaryBold: true,
  },
  "AL-PRO Sachet": {
    layout: "banner", primary: "AL-PRO", suffix: "SACHET",
    bg: "#ffffff", text: "#ea580c",
    accent: "#f97316", badge: "Sachet", italic: false, primaryBold: true,
  },
  "TACRORICH Forte": {
    layout: "script", primary: "TACRORICH", suffix: "Forte",
    bg: "#ffffff", text: "#1d4ed8",
    accent: "#0f766e", badge: "Ointment", italic: true,
  },
  "Richkast": {
    layout: "script", primary: "Richkast", suffix: "",
    bg: "#ffffff", text: "#dc2626",
    accent: "#1e3a8a", badge: "Tablets", italic: true,
  },
  "Myobrite-D": {
    layout: "capsule-split", primary: "Myobrite", suffix: "-D",
    bg: "#134e4a", bg2: "#f97316", text: "#f0fdfa", text2: "#ffffff",
    accent: "#5eead4", badge: "MELATONIN", italic: false, primaryBold: true,
  },
  "IT-Rich": {
    layout: "capsule-split", primary: "IT-Rich", suffix: "100 200",
    bg: "#065f46", bg2: "#f59e0b", text: "#ffffff", text2: "#78350f",
    accent: "#fef08a", badge: "100 & 200 mg", italic: false, primaryBold: true,
  },
  "Ketoend Soap/Cream": {
    layout: "script", primary: "Ketoend", suffix: "",
    bg: "#ffffff", text: "#1e3a8a",
    accent: "#0ea5e9", badge: "Soap / Cream", italic: true,
  },
  "TurmiRich": {
    layout: "script", primary: "TurmiRich", suffix: "",
    bg: "#ffffff", text: "#eab308",
    accent: "#b45309", badge: "Tablets", italic: true,
  },
  "LULIRICH": {
    layout: "banner", primary: "LULIRICH", suffix: "",
    bg: "#ffffff", text: "#15803d",
    accent: "#16a34a", badge: "Cream", italic: false, primaryBold: true,
  },
  "Ketoend Shampoo Lotion": {
    layout: "script", primary: "Ketoend", suffix: "",
    bg: "#ffffff", text: "#1e3a8a",
    accent: "#0ea5e9", badge: "Shampoo / Lotion", italic: true,
  },
  "Anditrip Forte": {
    layout: "script", primary: "Anditrip", suffix: "Forte",
    bg: "#ffffff", text: "#1e40af",
    accent: "#0ea5e9", badge: "Tablets", italic: true,
  },
  "SEBOEND": {
    layout: "banner", primary: "SEBOEND", suffix: "",
    bg: "#ffffff", text: "#1d4ed8",
    accent: "#1e3a8a", badge: "Cream", italic: false, primaryBold: true,
  },
  "Richkast-10": {
    layout: "rounded", primary: "Richkast", suffix: "-10",
    bg: "#f97316", bg2: "#ea580c", text: "#ffffff",
    accent: "#fed7aa", badge: "Tablets", italic: false, primaryBold: true,
  },
  "ANDITRIP": {
    layout: "banner", primary: "ANDITRIP", suffix: "",
    bg: "#ffffff", text: "#dc2626",
    accent: "#dc2626", badge: "Tablet", italic: false, primaryBold: true,
  },
  "SEBOEND-S": {
    layout: "capsule-split", primary: "SEBOEND", suffix: "-S",
    bg: "#7f1d1d", bg2: "#991b1b", text: "#ffffff", text2: "#ffffff",
    accent: "#fca5a5", badge: "Cream", italic: false, primaryBold: true,
  },
  "Richkast-25": {
    layout: "rounded", primary: "Richkast", suffix: "-25",
    bg: "#ea580c", bg2: "#c2410c", text: "#ffffff",
    accent: "#fed7aa", badge: "Tablets", italic: false, primaryBold: true,
  },
  "CereBrotin-90": {
    layout: "banner", primary: "CereBrotin", suffix: "-90",
    bg: "#ffffff", text: "#15803d", text2: "#f97316",
    accent: "#f97316", badge: "Tablets", italic: false, primaryBold: true,
  },
  "SEBOEND-CS Lotion": {
    layout: "capsule-split", primary: "SEBOEND-CS", suffix: "Lotion",
    bg: "#65a30d", bg2: "#4d7c0f", text: "#ffffff", text2: "#ffffff",
    accent: "#d9f99d", badge: "Lotion", italic: false, primaryBold: true,
  },
  "FUSIRICH-M Cream": {
    layout: "rounded", primary: "FUSIRICH-M", suffix: "",
    bg: "#fed7aa", bg2: "#fdba74", text: "#9a3412",
    accent: "#c2410c", badge: "Cream", italic: false, primaryBold: true,
  },
  "ANDITOP-DSR": {
    layout: "banner", primary: "ANDITOP-DSR", suffix: "",
    bg: "#ffffff", text: "#b91c1c",
    accent: "#dc2626", badge: "Capsules", italic: false, primaryBold: true,
  },
};

const FALLBACK = {
  layout: "rounded", primary: "Andrich", suffix: "",
  bg: "#1e3a8a", text: "#ffffff", accent: "#16a34a", badge: "", italic: false,
};

export function getBrand(name) {
  return PRODUCT_BRAND[name] || { ...FALLBACK, primary: name };
}
